import { useEffect } from "react";
import Navigation from "@/components/Navigation";
import SubHero from "@/components/SubHero";
import FmcgAbout from "@/components/FmcgAbout";
import FmcgBrands from "@/components/FmcgBrands";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";

export default function FmcgPage() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
    document.title = "FMCG Brand House — Catalyst Global Partners";
  }, []);

  return (
    <main data-testid="fmcg-page" className="bg-[#FAFAF7] text-[#0B1A36]">
      <Navigation />
      <SubHero
        overline="Division 02"
        title={
          <>
            Brands built with
            <br />
            <span className="italic text-white/65">taste, story &amp; soul.</span>
          </>
        }
        description="Catalyst incubates and operates a portfolio of modern Indian consumer brands — businesses with strong unit economics and even stronger storytelling. From sourcing to shelf, we own the journey end-to-end."
        image="https://images.unsplash.com/photo-1499636136210-6f4ee915583e?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400"
        primaryCta={{ label: "Explore Our Brands", href: "#fmcg-brands" }}
        secondaryCta={{ label: "Partner With Us", href: "#contact" }}
      />
      <FmcgAbout />
      <FmcgBrands />
      <ContactSection />
      <Footer />
    </main>
  );
}
